import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import Final from "./Final";
import { db } from "../../../firebase";
import fetchCancelationInsurance from "../../../Services/users/fetchCancelationInsurace";
import { sendSlackNotification } from "../../../Services/slack/sendSlackNotification";
import abandonCancelation from "../abandonCancelation";

const landingId = "CF_FINAL";

const onLoad = async ({ session, landedAt, uid, fieldsStructure }) => {
  try {
    const prevAnswers = {};
    const prevForm = await getFormSession(
      "cancelation-form",
      session.sessionID
    );
    const landings = prevForm.items;

    landings.forEach((item) => {
      if (item.answers.length > 0) {
        const lastField = item?.answers[0];
        const fieldID = lastField.field.id;
        const lastFieldType = lastField.type;
        const lastFieldAnswers = lastField[lastFieldType]?.value;
        prevAnswers[fieldID] = lastFieldAnswers;
      }
    });

    const productsToCancel = landings[0];
    const productsField = productsToCancel.answers[0];
    const productType = productsField.type;
    const products = productsField[productType].value;

    const devices = ["smartphone", "laptop", "tablet"];
    const isADeviceCheck = (d) => devices.includes(d) || d === "devices";
    const product = products[0];
    const docRef = doc(
      db,
      `users/${uid}/${
        isADeviceCheck(product.type) ? "smartphones" : "vehicles"
      }/${product.id}`
    );
    const docSnap = await getDoc(docRef);
    const productData = docSnap.data();

    const clientRef = doc(db, `users/${uid}`);
    const clientSnap = await getDoc(clientRef);
    const docData = clientSnap.data();
    const { phone, firstName, email, lastName } = docData;

    const { isPartialCancellation } = prevForm.metadata;
    const botChannelURL = `https://clupp-admin.web.app/clientes/whatsapp?phone=521${phone}`;
    const state = {
      userId: uid,
      ...prevAnswers,
      landedAt,
      prevForm,
      clientName: firstName,
      productName: `${productData.brand} ${productData.model}`,
      isADevice: isADeviceCheck(product.type),
      isMoreThanOne: products.length > 1,
      currentLanding: landingId,
      isPartialCancellation,
    };

    if (isPartialCancellation) {
      const mentions = ["U04422X2C8Y", "U026U082XRR"].map(
        (user) => `<@${user}>`
      );

      await sendSlackNotification({
        message: `${mentions} 📢 *El cliente ID:* ${uid}\n\n❌*Desea realizar una cancelación parcial*\n\n🔖 *Producto ID:* ${
          product.id
        }\n\n🛠️ *Producto:* ${productData.type} ${productData.brand} ${
          productData.model
        } ${
          productData.year || ""
        }\n\n👤 *Cliente*\n🔹 *Nombre:* ${firstName} ${lastName}\n🔹 *Email:* ${email}\n🔹 *Teléfono:* ${phone}\n\n🔗 <${botChannelURL}|*Clic aquí* para enviar mensaje por Canal del Bot.>`,
        chanelID: "C02GF3XHE92",
      });
    } else {
      await fetchCancelationInsurance({ uid });
      const productsIds = products.map((item) => item.id).join(" & ");
      await sendSlackNotification({
        message: `📢 *El cliente ID:* ${uid}\n\n❌*Realizó una cancelación total*\nProducto(s) ID(s): ${productsIds}\n🔖.👤 *Cliente*\n🔹 *Nombre:* ${firstName} ${lastName}\n🔹 *Email:* ${email}\n🔹 *Teléfono:* ${phone}\n\n🔗 <${botChannelURL}|*Clic aquí* para enviar mensaje por Canal del Bot.>`,
        chanelID: "C01SJBLK4H2",
      });
    }

    await abandonCancelation({
      session,
      state,
      uid,
      abandonmentType: "cancelation",
    });

    return state;
  } catch (err) {
    throw new Error(err.toString());
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <Final state={state} /> // Field ID
);

const nextPage = (props) => ``;
const prevPage = (props) => ``;

const fieldsStructure = [];

const finalProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default finalProps;
